import { useState } from "react";

export function NewCampaignModal({
  busy,
  error,
  onClose,
  onSubmit,
}: {
  busy: boolean;
  error: string | null;
  onClose: () => void;
  onSubmit: (values: { name: string; code: string; description: string }) => void;
}) {
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="new-campaign-title">
      <form
        className="modal-card new-campaign-modal"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit({ name: name.trim(), code: code.trim(), description: description.trim() });
        }}
      >
        <h3 id="new-campaign-title">New campaign</h3>
        <label className="campaign-builder-field">
          <span>Name</span>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="NBAA-BACE 2027"
            autoFocus
            required
            disabled={busy}
          />
        </label>
        <label className="campaign-builder-field">
          <span>Code</span>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="nbaa-bace-2027"
            required
            disabled={busy}
          />
        </label>
        <label className="campaign-builder-field">
          <span>Description</span>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="What this campaign is for"
            rows={3}
            disabled={busy}
          />
        </label>
        {error ? <p className="campaign-builder-error">{error}</p> : null}
        <div className="campaign-builder-actions">
          <button type="submit" disabled={busy || !name.trim() || !code.trim()}>
            {busy ? "Saving…" : "Create"}
          </button>
          <button type="button" className="secondary" onClick={onClose} disabled={busy}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
